// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"ManageCoupons_buttonContainer__Qz8ct","addButton":"ManageCoupons_addButton__2CUP6"};